import React from "react";
import { Button } from "reactstrap";
import { pick } from "lodash";
import { NotificationManager } from "react-notifications";
import { Trans, useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { useXeroClient } from "hooks";
import deepPick from "deepPick";

export const pickQuote = (item) => {
    const allowedProps = [
      "DocumentType",
      "Contact.ContactID",
      "Date",
      "ExpiryDate",
      "LineAmountTypes",
      "LineItems",
      "SubTotal",
      "TotalTax",
      "Total",
      "TotalDiscount",
      "CurrencyCode",
      "CurrencyRate",
      "QuoteID",
      "QuoteNumber",
      "Reference",
      "Title",
      "Summary",
      "Terms",
    ];
  
    const allowedItem = deepPick(item, allowedProps);
  
    allowedItem.ExpiryDate = allowedItem.ExpiryDate || undefined;
  
    return allowedItem;
  };

export const ConvertToInvoiceButton = ({ item, ...props }) => {
  const history = useHistory();
  const client = useXeroClient();
  const { t } = useTranslation();

  async function onConvertToInvoice() {
    let allowedItem = pickQuote(item);
    const { QuoteID } = allowedItem;
    let status = item.Status;

    try {
      if (status === "DRAFT") {
        await client.put(`quotes/${QuoteID}`, {
          Status: "SENT",
          ...allowedItem,
        });
        status = "SENT";
      }

      if (status === "SENT") {
        await client.put(`quotes/${QuoteID}`, {
          Status: "ACCEPTED",
          ...allowedItem,
        });
        status = "ACCEPTED";
      }

      if (status === "ACCEPTED") {
        await client.put(`quotes/${QuoteID}`, {
          Status: "INVOICED",
          ...allowedItem,
        });
        NotificationManager.success(t("Quote invoiced"));
      }
    } catch (ex) {
      console.error(ex);
      NotificationManager.error(t("Quote could not be set to Invoiced"));
    }

    history.push({
      pathname: "/accounts_receivable/invoices/edit/new",
      state: {
        copy: {
          Type: "ACCREC",
          Status: "DRAFT",
          Reference: item.QuoteNumber,
          ...pick(item, [
            "Contact",
            "Date",
            "LineAmountTypes",
            "LineItems",
            "SubTotal",
            "TotalTax",
            "Total",
            "TotalDiscount",
            "CurrencyCode",
            "CurrencyRate",
          ]),
        },
      },
    });
  }

  return (
    <Button onClick={onConvertToInvoice} {...props}>
      <Trans>Convert to Invoice</Trans>
    </Button>
  );
};

export const DocumentTypeMapping = {
  quotation: "Quotation Price",
  pro_forma_invoice: "Pro Forma Invoice",
}
